module.exports = __webpack_public_path__ + "img/G@2x.525c155.webp";